import { getCoords, getDragItemCoords, getEventData, isInRange, isInRect, passThreshold, } from "../dnd";
import { locate, locateID } from "@wx/lib-dom";
import { elementsIds } from "../constants";
import { splitAreaId } from "../helpers";
export function dndAction(node, config) {
    if (config.readonly) {
        return;
    }
    let clone;
    let handlers;
    const kanbanElement = node;
    let kanbanContent;
    let scrollTimer;
    let dragCoords;
    let pointerDownData;
    let dragItemsCoords;
    let dropAreaItemsCoords;
    let dropAreasCoords;
    let overAreaId;
    let before;
    let source;
    const dispatch = (name, data) => {
        config.api.exec(name, data);
        if (config.onAction) {
            config.onAction(name, data);
        }
    };
    const { data: dataStore } = config.api.getStores();
    const touch = {
        duration: 500,
        timer: null,
    };
    const touchStart = () => {
        if (touch.callback)
            touch.timer = setTimeout(touch.callback, touch.duration);
    };
    const touchEnd = () => {
        touch.timer && clearTimeout(touch.timer);
    };
    function checkScroll(e) {
        if (scrollTimer) {
            clearTimeout(scrollTimer);
        }
        if (kanbanContent) {
            const contentRect = kanbanContent.getBoundingClientRect();
            const scrollState = {
                x: kanbanContent.scrollLeft,
                y: kanbanContent.scrollTop,
            };
            const shift = 50;
            if (e.clientX > contentRect.width + contentRect.left - shift) {
                kanbanContent.scrollTo(scrollState.x + shift, scrollState.y);
            }
            if (e.clientX < contentRect.left + shift) {
                kanbanContent.scrollTo(scrollState.x - shift, scrollState.y);
            }
            if (e.clientY > contentRect.height + contentRect.top - shift) {
                kanbanContent.scrollTo(scrollState.x, scrollState.y + shift);
            }
            if (e.clientY < contentRect.top + shift) {
                kanbanContent.scrollTo(scrollState.x, scrollState.y - shift);
            }
            scrollTimer = setTimeout(() => {
                checkScroll(e);
            }, 100);
        }
    }
    function getOverItems(relativeCoords) {
        const items = {};
        const col = dropAreasCoords.find(col => {
            return isInRect(relativeCoords, col);
        });
        const areaId = col?.id;
        if (areaId) {
            const [columnId, rowId] = splitAreaId(areaId);
            items.overAreaId = { rowId, columnId };
            let y = relativeCoords.y;
            if (col.scrollList) {
                y +=
                    col.scrollList.node.scrollTop -
                        col.scrollList.initialScrollY;
            }
            const dragItems = dropAreaItemsCoords[areaId];
            items.before = dragItems.find(d => {
                return isInRange(y, [d.y, d.bottom]);
            })?.id;
        }
        return items;
    }
    function startDrag(ev, pointerCoords, relativeCoords, pointerDownData, selected) {
        if (ev.touches && ev.touches.length > 1) {
            return;
        }
        const id = pointerDownData.itemId;
        if (selected?.indexOf(id) === -1) {
            dispatch("select-card", { id });
            selected = [id];
        }
        dragCoords = getDragItemCoords(pointerCoords, pointerDownData, dragItemsCoords[id]);
        setDragItemClone(selected);
        const overItems = getOverItems(relativeCoords);
        before = overItems.before;
        overAreaId = overItems.overAreaId;
        source = selected || [id];
        dispatch("start-drag-card", {
            id,
            rowId: overAreaId.rowId,
            columnId: overAreaId.columnId,
            before,
            source,
            dragItemsCoords,
            dropAreasCoords,
        });
    }
    function moveDragItem(state, pointerCoords, relativeCoords, pointerDownData) {
        const { dragItemId } = state;
        const dragItemCoords = dragItemsCoords[pointerDownData.itemId];
        dragCoords = getDragItemCoords(pointerCoords, pointerDownData, dragItemCoords);
        clone.style.left = dragCoords.x + "px";
        clone.style.top = dragCoords.y + "px";
        const overItems = getOverItems(relativeCoords);
        const nextState = {
            id: dragItemId,
            rowId: overAreaId.rowId,
            columnId: overAreaId.columnId,
            before,
            source,
        };
        if (overItems.overAreaId?.columnId &&
            (nextState.rowId !== overItems.overAreaId?.rowId ||
                nextState.columnId !== overItems.overAreaId?.columnId)) {
            overAreaId = overItems.overAreaId;
            nextState.rowId = overAreaId.rowId;
            nextState.columnId = overAreaId.columnId;
        }
        if (before !== overItems.before) {
            before = nextState.before = overItems.before;
        }
        dispatch("drag-card", nextState);
    }
    function setDragItemClone(selected) {
        const kanban = document.querySelector(".wx-kanban");
        if (selected && selected.length > 1) {
            kanban.style.setProperty("--wx-kanban-dragged-cards-count", 
            // used to set variable value as string
            JSON.stringify(`${selected.length}`));
        }
        kanban.appendChild(clone);
        clone.classList.add("wx-dragged-card");
        clone.style.position = "fixed";
        clone.style.left = dragCoords.x + "px";
        clone.style.top = dragCoords.y + "px";
        document.body.classList.add("wx-ondrag");
    }
    function removeDragItemClone() {
        const kanban = document.querySelector(".wx-kanban");
        if (clone.parentNode) {
            kanban.removeChild(clone);
        }
        document.body.classList.remove("wx-ondrag");
        kanban.style.removeProperty("--wx-kanban-dragged-cards-count");
        clone = null;
    }
    function getPointerRelativeCoords(e, kanbanContent, pointerDownData) {
        const initialScroll = pointerDownData.scroll;
        const contentScroll = {
            x: kanbanContent.scrollLeft,
            y: kanbanContent.scrollTop,
        };
        const relativeCoords = {
            x: e.clientX + (contentScroll.x - initialScroll.x),
            y: e.clientY + (contentScroll.y - initialScroll.y),
        };
        return relativeCoords;
    }
    function downHandler(e) {
        const ev = getEventData(e);
        if ((ev.touches && ev.touches.length > 1) ||
            ("button" in e && e.button !== 0)) {
            return;
        }
        const source = locate(ev.target, "data-drag-item");
        kanbanContent = kanbanElement.querySelector(`[data-kanban-id="${elementsIds.content}"]`);
        if (source) {
            const itemId = locateID(source, "data-drag-item");
            const areaId = locateID(ev.target, "data-drag-item");
            const selected = dataStore.getState().selected;
            const itemsId = selected && selected.length > 1
                ? [...selected, itemId]
                : [itemId];
            const coords = getCoords(kanbanElement, itemsId);
            dragItemsCoords = coords.dragItemsCoords;
            dropAreasCoords = coords.dropAreasCoords;
            dropAreaItemsCoords = coords.dropAreaItemsCoords;
            clone = source.cloneNode(true);
            handlers =
                "touches" in e
                    ? { up: "touchend", move: "touchmove" }
                    : { up: "mouseup", move: "mousemove" };
            if ("touches" in e) {
                touch.callback = () => {
                    document.addEventListener(handlers.move, moveHandler);
                };
                touchStart();
            }
            else {
                document.addEventListener(handlers.move, moveHandler);
            }
            document.addEventListener(handlers.up, upHandler);
            pointerDownData = {
                x: ev.clientX,
                y: ev.clientY,
                itemId,
                itemsId,
                itemRect: dragItemsCoords[itemId],
                areaId,
                scroll: {
                    x: kanbanContent.scrollLeft,
                    y: kanbanContent.scrollTop,
                },
            };
        }
    }
    function moveHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        const ev = getEventData(e);
        checkScroll(ev);
        if (!pointerDownData) {
            return;
        }
        const state = dataStore.getState();
        const { selected, dragItemId } = state;
        const relativeCoords = getPointerRelativeCoords(ev, kanbanContent, pointerDownData);
        const pointerCoords = { x: ev.clientX, y: ev.clientY };
        if (!dragItemId && passThreshold(pointerDownData, pointerCoords)) {
            startDrag(ev, pointerCoords, relativeCoords, pointerDownData, selected);
        }
        if (dragItemId) {
            moveDragItem(state, pointerCoords, relativeCoords, pointerDownData);
        }
    }
    function upHandler() {
        document.removeEventListener(handlers.move, moveHandler);
        document.removeEventListener(handlers.up, upHandler);
        touchEnd();
        removeDragItemClone();
        if (scrollTimer) {
            clearTimeout(scrollTimer);
        }
        const { dragItemId } = dataStore.getState();
        if (dragItemId) {
            dispatch("end-drag-card", {
                id: dragItemId,
                rowId: overAreaId.rowId,
                columnId: overAreaId.columnId,
                before,
                source,
            });
        }
        pointerDownData = null;
    }
    kanbanElement.addEventListener("mousedown", downHandler);
    kanbanElement.addEventListener("touchstart", downHandler);
    kanbanElement.addEventListener("dragstart", e => e.preventDefault());
    return {
        destroy() {
            kanbanElement.removeEventListener("mousedown", downHandler);
            kanbanElement.removeEventListener("touchstart", downHandler);
        },
    };
}
//# sourceMappingURL=drag.js.map